var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"closewrap"},[_c('div',{staticClass:"closebody"},[_c('img',{attrs:{"src":require("@/assets/images/error.svg")}}),_c('h4',{staticClass:"closemsg"},[_vm._v("\n      "+_vm._s(_vm.$langt('網站已關閉或網站不存在!'))+"\n    ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }